import React from 'react';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { DEFAULT_GAMES_TAG_BACKGROUND } from '../../constants';
import { IProviderTagProps } from './types';

import styles from './index.module.css';

// to-check tagsConfig type after cms moved to ts
const ProviderTag: React.FC<IProviderTagProps> = ({ tag = '', tagsConfig }) => {
  const { t } = useI18n();
  const { tagBackground = DEFAULT_GAMES_TAG_BACKGROUND } =
    tagsConfig?.[tag] || {};

  if (!tag) {
    return null;
  }

  return (
    <Box className={styles.wrapper}>
      <Box
        className={styles.background}
        style={{ background: tagBackground }}
      />
      <Box padding="xs">
        <AText
          className={styles.label}
          color="txt_color_4"
          align="center"
          breed="BU"
          size="2xs"
        >
          {t(`web.providers.tag.${tag}`)}
        </AText>
      </Box>
    </Box>
  );
};

export default ProviderTag;
